program CadiaPZEWeb;

{$R *.dres}

uses
  Vcl.Forms,
  WEBLib.Forms,
  WEBLib.WebTools,
  Unit1 in 'Unit1.pas'{*.html},
  Unit2 in 'Unit2.pas',
  unit_Objektsuche in 'unit_Objektsuche.pas'{*.html},
  unit_BarcodeScan in 'unit_BarcodeScan.pas'{*.html},
  unit_Kontaktnummersuche in 'unit_Kontaktnummersuche.pas'{*.html},
  unit_Kontaktsuche in 'unit_Kontaktsuche.pas'{*.html},
  unit_AuftragSuche in 'unit_AuftragSuche.pas'{*.html},
  unit_ProduktionSuche in 'unit_ProduktionSuche.pas'{*.html};

{$R *.res}

begin
  Application.Initialize;
  Application.AutoFormRoute:=true;
  Application.MainFormOnTaskbar := True;
  Application.CreateForm(TForm1, Form1);
  Application.CreateFormDirect(TDM2, DM2);
  Application.Run;
end.
